import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import LangEn from '../../common/lang/en'
import LangZhCN from '../../common/lang/zh_CN'
import LangZhTW from '../../common/lang/zh_TW'
import LangRu from '../../common/lang/ru'
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueI18n)
import Register from './register.vue'
// import Login from 'components/login/login'
// import Register from 'components/register/register'
// import Config from 'common/script/config.js'
import czurUI from 'components/index.js'
Vue.use(czurUI)
import PhoneRegister from 'components/phoneRegister/phoneRegister'
import EmailRegister from 'components/emailRegister/emailRegister'
import Login from 'components/login/login'
import 'common/script/getRem.js'
import 'common/stylus/index.styl'
import Config from 'common/script/config.js'

Vue.http.options.emulateJSON = true
Vue.http.interceptors.push((request, next) => {
  // 请求发送前的处理逻辑
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.APP_KEY] = Config.APP_KEY
  // Vue.http.headers.common[Config.HTTP_HEADER_KEY.UDID] = navigator.appVersion
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.CHANNEL] = Config.getChannel()

  next((response) => {
    // ...
    // 请求发送后的处理逻辑
    // ...
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    return response
  })
})

const routes = [
{ path: '/', redirect: '/phone' },
  { path: '/phone', component: PhoneRegister },
  { path: '/email', component: EmailRegister },
  { path: '/gotoLogin', component: Login }
]

const router = new VueRouter({
  	routes
})

const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: {
    'en': LangEn,
    'zh-CN': LangZhCN,
    'zh-TW': LangZhTW,
    'ru_RU': LangRu
  }
})

// 检测浏览器语言
var currentLang = Config.lang()

setI18nLanguage(currentLang)

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang) // 根元素增加lang属性
  return lang
}

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  },
  update: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
	router,
  i18n,
	render: h => h(Register)
}).$mount('#register')



// WEBPACK FOOTER //
// ./src/module/register/register.js